import React, { FC } from 'react';
import { Button, Card } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PageContainer, Title, faBarsProgress } from '@/ui/components';
import { useTranslate } from '@/translations';
import { SystemAdministrationRoutes } from '@/routes';
import { JobTagManagement } from './JobTags/JobTagManagement';
import { JobTemplatesDataGrid } from './JobTemplates/JobTemplatesDataGrid';

export const AdminJobs: FC = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Title title={t('manageJobs')} icon={faBarsProgress} />

      <Card title={t('jobChainTemplatesTitle')}>
        <Button
          type="primary"
          onClick={() => navigate(SystemAdministrationRoutes.jobChainTemplates)}
        >
          {t('jobChainTemplatesManageAction')}
        </Button>
      </Card>

      <Card>
        <JobTagManagement />
      </Card>

      <Card title="Job Templates">
        <JobTemplatesDataGrid />
      </Card>
    </PageContainer>
  );
};
